<template>
  <header class="main-header">
    <span class="logo-mini">
      
      <router-link :to="{ name: 'dashboard'}">
        <a href="/">
        <!-- <img src="/static/img/brand-logo.png" alt="Logo" class="img-responsive center-block logo logo1" /> -->
        <!-- <img src="/static/img/logo-white1.png" alt="Logo" class="img-responsive center-block logo logo" /> -->
        <!-- <img src="/static/img/coloredLogo.png" alt="Logo" class="img-responsive center-block logo logo2" /> -->
        </a>
      </router-link>
      
    </span>
    <!-- Header Navbar -->
    
    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->
      <span style="width:16%">
      <a href="javascript:;" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      </span>
        <span class="logo-mini col-xs-8" style="text-align:center">
        <b><h2 class=" logo1" style="margin-bottom: 12px;font-size: 22px;color: black;font-weight: 900;margin-top: 12px;margin-left: 65px;">HASHBULLS ALGOTRADE PLATFORM </h2></b>
        <h2 class="logo3 " style="margin-bottom: 1px;font-size: 22px;color: black;font-weight: 900;margin-top: 13px" >HASHBULLS ALGOTRADE PLATFORM  </h2>
        </span>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav" style="float: right;">
          <!-- Notifications Menu -->
          <li class="dropdown notifications-menu">
            <ul class="dropdown-menu" id="dropdown-notifications-menu">
              <li class="header">You have {{ unreadNotificationsCount }} notification(s)</li>
              <li v-if="notifications.length > 0">
                <!-- Inner Menu: contains the notifications -->
                <ul class="menu">
                  <li
                    v-for="(notification, index) in notifications"
                    :class="{ 'message-unread': !notification.hasRead }"
                    :key="index"
                  >
                    <!-- start notification -->
                    <a href="javascript:;" @click="goToProfile(notification.actingUser)">
                      <img
                        class="contacts-list-img"
                        :src="notification.actingUser.profileImageUrl"
                        alt="Contact Avatar"
                      />
                      <div class="message-list-info">
                        <span class="message-list-name">
                          <span>{{notification.actingUser.firstName}} {{notification.actingUser.lastName}}</span>
                          <small
                            class="message-list-date pull-right"
                          >{{notification.createdAt | moment("MMM D, h:mm a")}}</small>
                        </span>
                        <div>
                          <span class="message-list-msg">{{notification.message}}</span>
                          <span class="message-list-dot" v-if="notification.hasRead">
                            <button
                              type="button"
                              class="btn btn-box-tool"
                              v-tooltip="'Mark as unread'"
                              @click.stop="markNotificationAsUnread(notification)"
                            >
                              <i class="fa fa-dot-circle-o"></i>
                            </button>
                          </span>
                          <span class="message-list-dot" v-else>
                            <button
                              type="button"
                              class="btn btn-box-tool"
                              v-tooltip="'Mark as read'"
                              @click.stop="markNotificationAsRead(notification)"
                            >
                              <i class="fa fa-circle"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <!-- end notification -->
                </ul>
              </li>
              <li class="footer" v-if="notifications.length > 0">
                <!--<a href="javascript:;">View all</a>-->
                <a
                  href="javascript:;"
                  class="message-menu-link"
                  @click.stop="markAllNotificationsAsRead"
                >Mark All as Read</a>
              </li>
            </ul>
          </li>

          <!-- User Account Menu -->
          <li class="dropdown user user-menu">
            <!-- Menu Toggle Button -->
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <!-- The user image in the navbar-->
              <img :src="pictureUrl" class="user-image" alt="User Image" />
              <!-- hidden-xs hides the username on small devices so only the image appears. -->
              <span class="hidden-xs">{{user.firstName}} {{user.lastName}}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- The user image in the menu -->
              <li class="user-header">
                <img :src="pictureUrl" class="img-circle" alt="User Image" />

                <p>
                  {{user.firstName}} {{user.lastName}} - {{user.roleName}}
                  <small>Member since {{user.createdAt | moment("MMMM, YYYY")}}</small>
                </p>
              </li>
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <router-link to="/profile">
                    <a href="#" class="btn btn-default btn-flat">Profile</a>
                  </router-link>
                </div>
                <div class="pull-right">
                  <a href="#" @click="logout" class="btn btn-default btn-flat">Log out</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>

    <notifications></notifications>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import { authService, eventBus } from '../../../services';
import { EVENTS, CHAT_TYPES } from '../../../config';
import Notifications from '../../utilities/Notifications.vue';

export default {
  name: 'MainHeader',
  components: {
    Notifications,
  },
  props: ['displayName', 'pictureUrl'],
  data() {
    return {
      ready: false,
      loading: false,
      CHAT_TYPES: CHAT_TYPES,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      userInfo: state => state.userInfo,
      conversations: state => state.conversations,
      notifications: state => state.notifications,
    }),
    unreadConversationsCount() {
      return this.conversations.reduce((count, conversation) => {
        if (conversation.hasRead) {
          return count;
        } else {
          return count + 1;
        }
      }, 0);
    },
    unreadNotificationsCount() {
      return this.notifications.reduce((count, notification) => {
        if (notification.hasRead) {
          return count;
        } else {
          return count + 1;
        }
      }, 0);
    },
  },
  methods: {
    logout() {
      this.loading = true;
      localStorage.clear()
          sessionStorage.clear()
           var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++){   
            var spcook =  cookies[i].split("=");
            document.cookie = spcook[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";                                
        }
          this.$router.push('/login');
          this.$router.go()
      authService
        .logout()
        .then(response => {
          this.loading = false;
          this.$snotify.success('Log Out successful', 'Success!');
          
        })
         
          
        .catch(error => {
          this.loading = false;
          console.error('MainHeader.logout-error:', error);
          // this.$snotify.error('Log Out failed', 'Error!');
        });
    },
    openNewGroupBox() {
      eventBus.$emit(EVENTS.OPEN_CHAT_CREATE);
    },
    openNewMessageBox() {
      eventBus.$emit(EVENTS.OPEN_CHAT, { new: true });
    },
    openChatBox(conversation) {
      eventBus.$emit(EVENTS.OPEN_CHAT, { conversation });
    },
    markConversationAsRead(conversation) {
      eventBus.$emit(EVENTS.MARK_CONVERSATION_AS_READ, conversation);
    },
    markConversationAsUnread(conversation) {
      eventBus.$emit(EVENTS.MARK_CONVERSATION_AS_UNREAD, conversation);
    },
    markAllConversationsAsRead() {
      for (let conversation of this.conversations) {
        if (!conversation.hasRead) {
          this.markConversationAsRead(conversation);
        }
      }
    },
    markNotificationAsRead(notification) {
      eventBus.$emit(EVENTS.MARK_NOTIFICATION_AS_READ, notification);
    },
    markNotificationAsUnread(notification) {
      eventBus.$emit(EVENTS.MARK_NOTIFICATION_AS_UNREAD, notification);
    },
    markAllNotificationsAsRead() {
      for (let notification of this.notifications) {
        if (!notification.hasRead) {
          this.markNotificationAsRead(notification);
        }
      }
    },
    userListTooltip(users) {
      let list = '';
      for (let user of users) {
        if (list === '') {
          list = list + user.firstName + ' ' + user.lastName;
        } else {
          list = list + ', ' + user.firstName + ' ' + user.lastName;
        }
      }
      return list;
    },
    goToProfile(user) {
      this.$router.push({
        name: 'MemberProfile',
        params: { _id: user._id },
        props: user,
      });
    },
  },
  mounted: function() {},
};
</script>

<style lang="scss">
.logo2{
    display: none !important;
  }
 .logo3{
    display: none !important;
    
  } 
.sidebar-collapse{
  .logo2{
    display: block !important;
  }
  .logo1{
    display: none;
  }
  .logo3{
    display: block !important;
    margin-left: 200px;
  }
  
}
.message-list-img {
  border-radius: 50%;
  width: 40px;
  float: left;
}
.message-list-info {
  margin-left: 45px;
}
.message-list-name {
  font-weight: 600;
  display: block;
}
.message-list-msg {
  color: #999;
}
.message-list-dot {
  float: right;
  .btn-box-tool {
    color: #97a0b3;
  }
  .btn-box-tool:hover {
    color: #333;
  }
}
.message-unread {
  background-color: #f2f5fd;
}
#dropdown-messages-menu {
  width: 450px;
  .footer {
    border-top: 1px solid #eeeeee;
  }
  li {
    a.message-menu-link {
      color: cornflowerblue;
      &:hover {
        text-decoration: underline;
        background-color: inherit;
      }
    }
  }
}
#dropdown-notifications-menu {
  width: 450px;
  .footer {
    border-top: 1px solid #eeeeee;
  }
  li {
    a.message-menu-link {
      color: cornflowerblue;
      &:hover {
        text-decoration: underline;
        background-color: inherit;
      }
    }
  }
}
.menu {
  li {
    border-bottom: 1px solid #eeeeee;
  }
}
</style>



// WEBPACK FOOTER //
// MainHeader.vue?033a1bdd